import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Item } from '../../model/item';
import { Answer } from '../../model/answer';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { CONFIG } from '../../constants/constants';

/*Servicio  para borrado de todos los datos
  almacenados en indexedDB*/
@Injectable({
  providedIn: 'root'
})
export class DeleteService {

  //Objeto para acceso a la base de datos IndexedDB
  private dataBase: any = null;

  ///constructor de la clase
  constructor(private http: HttpClient) {
  }

  /*Se encarga de vaciar el contenido de los 'stores'
    para esto abre conexion con el store de items, cuando es exitosa
    la conexion, elimina todos los registros y se conecta con el stroe de
    respuestas (ANSWER_STORE) y realiza el mismo procedimiento de borrado,
    luego continua con el TOKEN_STORE y por ultimo con el STATE_STORE
    cuando termina el borrado resuelve la promesa */
  public deleteDatabase() {
    let self = this;
    return new Promise<void>(resolve => {
      self.dataBase = indexedDB.open(CONFIG.DB_NAME);
      self.dataBase.onupgradeneeded = function (event: any) { }
      self.dataBase.onsuccess = function (event: any) {
        let connection = self.dataBase.result;
        let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readwrite');
        let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
        let objectStoreRequest = objStore.clear();
        objectStoreRequest.onsuccess = function (event: any) {
          let transactionAns =
            connection.transaction([CONFIG.ANSWER_STORE], 'readwrite');
          let objStoreAns = transactionAns.objectStore(CONFIG.ANSWER_STORE);
          let objectStoreRequestAns = objStoreAns.clear();
          objectStoreRequestAns.onsuccess = function (event: any) {
            let transactionTok =
              connection.transaction([CONFIG.TOKEN_STORE], 'readwrite');
            let objStoreToken = transactionTok.objectStore(CONFIG.TOKEN_STORE);
            let objectStoreRequestToken = objStoreToken.clear();
            objectStoreRequestToken.onsuccess = function (event: any) {
              let transactionState =
                connection.transaction([CONFIG.STATE_STORE], 'readwrite');
              let objStoreState = transactionState.objectStore(CONFIG.STATE_STORE);
              let objectStoreRequestState = objStoreState.clear();
              objectStoreRequestState.onsuccess = function (event: any) {
                resolve(undefined);
              }
              objectStoreRequestState.onerror = function (event: any) {
                console.log('error deleting state');
                resolve();
              }
            }
            objectStoreRequestToken.onerror = function (event: any) {
              console.log('error deleting token');
              resolve();
            }
          }
          objectStoreRequestAns.onerror = function (event: any) {
            console.log('error deleting answers');
            resolve();
          }
        }
        objectStoreRequest.onerror = function (event: any) {
          console.log('error deleting items');
          resolve();
        }
      }
      self.dataBase.onerror = function (event: any) {
        console.log('...error opening dataBase...');
        resolve();
      }
    });
  }

  /*Se encarga de realizar un proceso de borrado cuando
    se detecta un cambio de usuario*/
  public deleteTablesChangeUser() {
    let self = this;
    return new Promise(resolve => {
      self.dataBase = indexedDB.open(CONFIG.DB_NAME);
      self.dataBase.onupgradeneeded = function (event: any) { }
      self.dataBase.onsuccess = function (event: any) {
        console.log('Inicio borrado usuario diferente');
        let connection = self.dataBase.result;
        let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readwrite');
        let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
        let objectStoreRequest = objStore.clear();
        objectStoreRequest.onsuccess = function (event: any) {
          let transactionAns =
            connection.transaction([CONFIG.ANSWER_STORE], 'readwrite');
          let objStoreAns = transactionAns.objectStore(CONFIG.ANSWER_STORE);
          let objectStoreRequestAns = objStoreAns.clear();
          objectStoreRequestAns.onsuccess = function (event: any) {
            let transactionState =
              connection.transaction([CONFIG.STATE_STORE], 'readwrite');
            let objStoreState = transactionState.objectStore(CONFIG.STATE_STORE);
            let objectStoreRequestState = objStoreState.clear();
            objectStoreRequestState.onsuccess = function (event: any) {
              console.log('Ok deleting state');
              resolve(undefined);
            }
            objectStoreRequestState.onerror = function (event: any) {
              console.log('error deleting state');
              resolve(undefined);
            }
          }
          objectStoreRequestAns.onerror = function (event: any) {
            console.log('error deleting answers');
            resolve(undefined);
          }
        }
        objectStoreRequest.onerror = function (event: any) {
          console.log('error deleting items');
          resolve(undefined);
        }
      }
      self.dataBase.onerror = function (event: any) {
        console.log('...error opening dataBase...');
        resolve(undefined);
      }
    });
  }

  /** Elimina los datos al darle salir */
  public deleteDatabaseOnExit() {
    let self = this;
    return new Promise(resolve => {
      self.dataBase = indexedDB.open(CONFIG.DB_NAME);
      self.dataBase.onupgradeneeded = function (event: any) { }
      self.dataBase.onsuccess = function (event: any) {
        let connection = self.dataBase.result;
        let transaction = connection.transaction([CONFIG.ITEMS_STORE], 'readwrite');
        let objStore = transaction.objectStore(CONFIG.ITEMS_STORE);
        let objectStoreRequest = objStore.clear();
        objectStoreRequest.onsuccess = function (event: any) {
          let transactionAns =
            connection.transaction([CONFIG.ANSWER_STORE], 'readwrite');
          let objStoreAns = transactionAns.objectStore(CONFIG.ANSWER_STORE);
          let objectStoreRequestAns = objStoreAns.clear();
          objectStoreRequestAns.onsuccess = function (event: any) {
            let transactionState =
              connection.transaction([CONFIG.STATE_STORE], 'readwrite');
            let objStoreState = transactionState.objectStore(CONFIG.STATE_STORE);
            let objectStoreRequestState = objStoreState.clear();
            objectStoreRequestState.onsuccess = function (event: any) {
              console.log('Ok deleting state');
              resolve(undefined);
            }
            objectStoreRequestState.onerror = function (event: any) {
              console.log('error deleting state');
              resolve(undefined);
            }
          }
          objectStoreRequestAns.onerror = function (event: any) {
            console.log('error deleting answers');
            resolve(undefined);
          }
        }
        objectStoreRequest.onerror = function (event: any) {
          console.log('error deleting items');
          resolve(undefined);
        }
      }
      self.dataBase.onerror = function (event: any) {
        console.log('...error opening dataBase...');
        resolve(undefined);
      }
    });
  }


}
